import { render, staticRenderFns } from "./MixerLoadsListMobile.vue?vue&type=template&id=fb350a48&lang=pug&"
import script from "./MixerLoadsListMobile.vue?vue&type=script&lang=js&"
export * from "./MixerLoadsListMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports